(function () {
    'use strict';

    angular
        .module('franchiser.components', []);

    angular
        .module('franchiser.directives', []);

    angular
        .module('franchiser.filters', []);

    angular
        .module('franchiser.interceptors', []);

    angular
        .module('franchiser.routes', []);

    angular
        .module('franchiser.services', []);

    angular
        .module('franchiser.constants', []);
}());